module.exports = {"652825100":"且末镇","652825101":"奥依亚依拉克镇","652825102":"塔提让镇","652825103":"塔中镇","652825104":"阿羌镇","652825105":"阿热勒镇","652825201":"琼库勒乡","652825202":"托格拉克勒克乡","652825203":"巴格艾日克乡","652825204":"英吾斯塘乡","652825205":"阿克提坎墩乡","652825206":"阔什萨特玛乡","652825209":"库拉木勒克乡","652825501":"兵团三十七团","652825502":"兵团三十八团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652825.json
// module id = 3086
// module chunks = 0